import { render, staticRenderFns } from "./bus_on_road.vue?vue&type=template&id=dc419108&"
import script from "./bus_on_road.vue?vue&type=script&lang=js&"
export * from "./bus_on_road.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports